/** Listing `status` value Peerspace sets when it pauses a listing internally. */
export const PAUSED_INTERNALLY_STATUS = "PAUSED_INTERNALLY";

/** Help center article opened when a host clicks a paused-listing card. */
export const PAUSED_LISTING_HELP_URL =
  "https://support.peerspace.com/en/articles/13047194-why-was-my-peerspace-listing-paused";

/** Square thumbnail size (px) used for the listing image on each paused row. */
export const PAUSED_LISTING_THUMBNAIL_PX = 120;

/** Space name is truncated past this length so the card title stays on-brand. */
export const PAUSED_LISTING_SPACE_NAME_MAX_LENGTH = 25;
